import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import infoIcon from "../../assets/images/infobtnblue.svg";
import CKeditorComponent from "../common-component/CKeditorComponent";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import {
  UpdateMachine,
  UpdateReviewComment,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { rejectParameterState } from "../../services/ReduxTookit/UserInfoSlice";

const ParameterEditMarketplaceModal = (props) => {
  

  const dispatch = useDispatch();
  const countFalseValues = () => {
    return Object.values(props?.geteditstatus).filter(
      (value) => value === false
    ).length;
  };
  const [Loading, setLoading] = useState(false);
  const [input, setinput] = useState({
    machineid: "",
    price: "",
    subcategoryid: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: "",
    dependentmachineids: "",
    cloud: "",
  });
  const [Newmachineparameter, setNewmachineparameter] = useState({
    parakey: "",
    paratype: "",
    paravalueselection: "",
    details: "",
    machineconfigparaid: "",
    errors: {
      parakey: "",
      paratype: "",
      paravalueselection: "",
      details: "",
      ValidationRules: [
        {
          FieldName: "parakey",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "paratype",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "details",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const [ProjectTermList, setProjectTermList] = useState({
    CPU: [],
    OS: [],
    RAM: [],
    Storage: [],
    Cloud: [],
    InputType: [],
  });
  async function getProjectTermList() {
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.PROJECTTERMGETLIST,
    //   },
    //   false
    // );
    // let response = apiResponse(false, resData);
    dispatch(ProjectTermGetList({}))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          let cloudarray = [];
          response?.payload?.data?.data.forEach((element) => {
            if (element?.category === "Cloud") {
              cloudarray.push({
                value: element?.term,
                label: element?.term,
              });
            }
          });
          setProjectTermList({
            CPU: response?.payload?.data?.data.filter(
              (f) => f.category === "CPU"
            ),
            OS: response?.payload?.data?.data.filter(
              (f) => f.category === "Operating system"
            ),
            RAM: response?.payload?.data?.data.filter(
              (f) => f.category === "RAM"
            ),
            Storage: response?.payload?.data?.data.filter(
              (f) => f.category === "Storage"
            ),
            InputType: response?.payload?.data?.data.filter(
              (f) => f.category === "Input Type"
            ),
            Cloud: cloudarray,
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  useEffect(() => {
    getProjectTermList();
  }, []);

  useEffect(() => {
    if (props?.machinedata) {
      setinput({
        ...input,
        machineid: props?.machinedata?.dataList1?.[0]?.machineid
          ? props?.machinedata?.dataList1?.[0]?.machineid
          : 0,
        price: props?.machinedata?.dataList1?.[0]?.price
          ? props?.machinedata?.dataList1?.[0]?.price
          : 0,
        subcategoryid: props?.machinedata?.dataList1?.[0]?.subcategoryid
          ? props?.machinedata?.dataList1?.[0]?.subcategoryid
          : 0,
        osrequirmet: props?.machinedata?.dataList2?.[0]?.osrequirmet,
        storage: props?.machinedata?.dataList2?.[0]?.storage,
        ram: props?.machinedata?.dataList2?.[0]?.ram,
        cpu: props?.machinedata?.dataList2?.[0]?.cpu,
        compatiblemachineids:
          props?.machinedata?.dataList2?.[0]?.compatiblemachineids,
        dependentmachineids:
          props?.machinedata?.dataList2?.[0]?.dependentmachineids,
        cloud: props?.machinedata?.dataList2?.[0]?.cloud,
      });
    }
  }, [props?.machinedata]);

  useEffect(() => {
    if (props?.type === "Edit") {
      setNewmachineparameter({
        ...Newmachineparameter,
        parakey: props?.selecteddata?.parakey || "",
        paratype: props?.selecteddata?.paratype || "",
        paravalueselection: props?.selecteddata?.paravalueselection || "",
        machineconfigparaid: props?.selecteddata?.machineconfigparaid || "",
        details: props?.selecteddata?.details
          ? props?.selecteddata?.details
          : "",
      });
    }
  }, [props?.selecteddata]);
  const paramArray = useSelector(
    (state) => state?.userinfo?.RejectParametersData
  );
  

  const UpdateMachineData = (e) => {
    e.preventDefault();
    let NewData = props?.machinedata?.dataList3;
    let errors = Newmachineparameter.errors;
    if (
      Newmachineparameter.paratype !== "Dropdown Single Select" &&
      Newmachineparameter.paratype !== "Dropdown Multiple Select"
    ) {
      errors.paravalueselection = "";
    }
    if (
      Newmachineparameter.paratype === "Dropdown Single Select" ||
      Newmachineparameter.paratype === "Dropdown Multiple Select"
    ) {
      let CheckJson = commonservices.IsValidJson(
        Newmachineparameter?.paravalueselection
      );
      if (CheckJson) {
        errors.paravalueselection = "";
      } else {
        errors.paravalueselection = "Enter valid Json format";
      }
    }
    let obj = commonservices.fnCheckValidationOfObject(Newmachineparameter);
    setNewmachineparameter({
      ...obj.obj,
    });
    if (obj.isValid && !errors.paravalueselection) {
      const updatedData = NewData.map((item) => {
        if (
          item.machineconfigparaid === Newmachineparameter.machineconfigparaid
        ) {
          return {
            ...item,
            parakey: Newmachineparameter.parakey,
            paratype: Newmachineparameter.paratype,
            paravalueselection: Newmachineparameter.paravalueselection,
            details: Newmachineparameter.details,
          };
        }
        return item;
      });
      let DataList = { ...props?.machinedata };
      if (DataList) {
        DataList.dataList3 = updatedData;
      }

      props.setmachinedetails(DataList);
      let a = paramArray?.filter(
        (item) =>
          item.machineconfigparaid !== Newmachineparameter.machineconfigparaid
      );

      dispatch(rejectParameterState(a));

      props.onHide();
    }

    // if (a?.length > 0) {
    // } else {
    //   updateReviewStatus(e);
    // }
  };

  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let errors = Newmachineparameter.errors;
    if (
      Newmachineparameter.paratype !== "Dropdown Single Select" &&
      Newmachineparameter.paratype !== "Dropdown Multiple Select"
    ) {
      errors.paravalueselection = "";
    }
    if (
      Newmachineparameter.paratype === "Dropdown Single Select" ||
      Newmachineparameter.paratype === "Dropdown Multiple Select"
    ) {
      let CheckJson = commonservices.IsValidJson(
        Newmachineparameter?.paravalueselection
      );
      if (CheckJson) {
        errors.paravalueselection = "";
      } else {
        errors.paravalueselection = "Enter valid Json format";
      }
    }
    let obj = commonservices.fnCheckValidationOfObject(Newmachineparameter);
    setNewmachineparameter({
      ...obj.obj,
    });
    if (obj.isValid && !errors.paravalueselection) {
      setLoading(true);
      let newbody = {
        machineid: props?.versionlist?.machineid,
        versionnumber: props?.versionlist?.number,
        booleanfield: props?.updatereviewcommentdata?.booleanfield,
        commentfield: props?.updatereviewcommentdata?.commentfield,
        commentfieldvalue: props?.updatereviewcommentdata?.commentfieldvalue,
      };
      dispatch(UpdateReviewComment(newbody))?.then((response) => {
        if (response?.payload?.isValidate) {
          handleSubmit();
        }
        if (!response?.payload?.isValidate) {
        }
      });
    }
  };
  const handleSubmit = async (e) => {
    let formData = new FormData();
    let prevdata = [];
    props?.machinedata?.dataList3?.forEach((element) => {
      if (props?.type === "Edit") {
        if (
          element?.machineconfigparaid ===
          props?.selecteddata?.machineconfigparaid
        ) {
          const updatedElement = {
            ...element,
            parakey: Newmachineparameter?.parakey,
            paratype: Newmachineparameter?.paratype,
            paravalueselection: Newmachineparameter?.paravalueselection,
            detail: Newmachineparameter?.details,
          };
          prevdata.push(updatedElement);
        } else {
          prevdata.push({
            parakey: element?.parakey,
            paratype: element?.paratype,
            paravalueselection: element?.paravalueselection,
            detail: element?.details,
          });
        }
      } else {
        prevdata.push({
          parakey: element?.parakey,
          paratype: element?.paratype,
          paravalueselection: element?.paravalueselection,
          detail: element?.details,
        });
      }
    });

    if (props?.type !== "Edit") {
      prevdata.push({
        parakey: Newmachineparameter?.parakey,
        paratype: Newmachineparameter?.paratype,
        paravalueselection: Newmachineparameter?.paravalueselection,
        detail: Newmachineparameter?.details,
      });
    }
    let tempobj = [...prevdata];

    const updatedMachineDetails = {
      ...props?.machinedata,
      dataList3: tempobj,
    };

    let body = {
      machineid: input?.machineid,
      price: input?.price ? input?.price : 0,
      subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
      osrequirmet: input?.osrequirmet,
      storage: input?.storage,
      ram: input?.ram,
      cpu: input?.cpu,
      compatiblemachineids: input?.compatiblemachineids,
      dependentmachineids: input?.dependentmachineids,
      cloud: input?.cloud,
      machineconfigparameter: tempobj,
      status: countFalseValues() === 1 ? "In Process" : "Rejected",
    };

    dispatch(UpdateMachine(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        props.onHide();
        props?.setmachinedetails(updatedMachineDetails);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  const fnInputChange = (value, tag) => {
    if (value) {
      setNewmachineparameter({
        ...Newmachineparameter,
        [tag]: value,
        errors: {
          ...Newmachineparameter.errors,
          [tag]: "",
        },
      });
    } else {
      setNewmachineparameter({
        ...Newmachineparameter,
        [tag]: "",
      });
    }
  };

  // Add or remove 'loadtime' class based on MachineLoader

 useEffect(() => {
  if (Loading) {
    document.body.classList.add('loadtime');
  } 
  // else {
  //   document.body.classList.remove('loadtime');
  // }

  // Cleanup when component unmounts
  return () => {
    document.body.classList.remove('loadtime');
  };
}, [Loading]); // Re-run this effect when MachineLoader changes

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.type} Parameter
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          // if (props?.type === "Edit") {
          // if (paramArray?.length > 0) {
          UpdateMachineData(e);
          // } else {
          //   updateReviewStatus(e);
          // }
          // } else if (props?.type === "Add") {
          //   updateReviewStatus(e);
          // }
        }}
      >
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Name<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    maxLength={67}
                    className="common-input"
                    value={Newmachineparameter?.parakey}
                    onChange={(e) => fnInputChange(e.target.value, "parakey")}
                    isInvalid={Newmachineparameter?.errors?.parakey}
                  />
                  {Newmachineparameter.errors.parakey && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.parakey}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Type<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Select
                    className="common-select"
                    value={Newmachineparameter?.paratype}
                    onChange={(e) => fnInputChange(e.target.value, "paratype")}
                    isInvalid={Newmachineparameter?.errors?.paratype}
                  >
                    <option value="">Select</option>
                    {ProjectTermList.InputType?.length > 0 &&
                      ProjectTermList.InputType?.map((item_cd, index_cd) => (
                        <option key={index_cd} value={item_cd?.term}>
                          {item_cd?.term}
                        </option>
                      ))}
                  </Form.Select>
                  {Newmachineparameter.errors.paratype && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.paratype}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            {(Newmachineparameter?.paratype === "Dropdown Single Select" ||
              Newmachineparameter?.paratype === "Dropdown Multiple Select") && (
              <Col md={12}>
                <Form.Group className="form-group mb16">
                  <Form.Label className="common-label">
                    Selection Value (As a Array List)
                    <span className="ms-1 red-color-text">*</span>
                  </Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      as="textarea"
                      placeholder={`["1","2","3"]`}
                      className="common-input"
                      value={Newmachineparameter?.paravalueselection}
                      onChange={(e) => {
                        if (e.target.value.startsWith("[")) {
                          setNewmachineparameter({
                            ...Newmachineparameter,
                            paravalueselection: e.target.value,
                          });
                        } else {
                          setNewmachineparameter({
                            ...Newmachineparameter,
                            paravalueselection: "",
                          });
                        }
                      }}
                      isInvalid={
                        Newmachineparameter?.errors?.paravalueselection
                      }
                    />
                    {Newmachineparameter.errors.paravalueselection && (
                      <Form.Control.Feedback type="invalid">
                        <span className="error-message-icon">
                          <img
                            src={infoIcon}
                            alt="infoIcon"
                            title={
                              Newmachineparameter.errors.paravalueselection
                            }
                          />
                        </span>
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Form.Group>
              </Col>
            )}
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Detail<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <div
                    className={`${
                      Newmachineparameter.errors.details && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={(e) => fnInputChange(e, "details")}
                      tag="details"
                      value={Newmachineparameter?.details}
                    />
                  </div>
                  {Newmachineparameter.errors.details && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.details}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="grey-btn w-auto" onClick={props.onHide}>
            Close
          </button>
          <button disabled={Loading} className="blue-btn w-auto" type="submit">
            {Loading ? <SubmitLoading /> : "Submit"}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ParameterEditMarketplaceModal;
